module.exports = __webpack_public_path__ + "img/30087804_253872848488989_8792603541668626432_n.2f9dea03.jpg";